import {
  toEmailCopyToEntityApiDataBuilding,
  toEmailCopyToEntityApiDataFlat,
  toEmailCopyToEntityApiDataUser,
} from '../../../EmailCopyToEntityModal'

import BuildingIcon from '../../../../../icons/building.svg'
import FlatIcon from '../../../../../icons/flat.svg'

export const COPIED_TO_TAG_LIST_ENTITY = {
  Building: 'building',
  Flat: 'flat',
  User: 'user_profiles',
}

export const COPIED_TO_TAG_LIST_FUNCTION_BY_ENTITY = {
  [COPIED_TO_TAG_LIST_ENTITY.Building]: toEmailCopyToEntityApiDataBuilding,
  [COPIED_TO_TAG_LIST_ENTITY.Flat]: toEmailCopyToEntityApiDataFlat,
  [COPIED_TO_TAG_LIST_ENTITY.User]: toEmailCopyToEntityApiDataUser,
}

export const COPIED_TO_TAG_LIST_ENTITY_ICON = {
  [COPIED_TO_TAG_LIST_ENTITY.Building]: BuildingIcon,
  [COPIED_TO_TAG_LIST_ENTITY.Flat]: FlatIcon,
}
